var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApoioDecisao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "apoio-decisao",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171 171",
    style: {
      enableBackground: "new 0 0 171 171"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD5100;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "apoio-decisao_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.7,57.8c6.7,0,12.2-5.5,12.2-12.2c0-6.7-5.5-12.2-12.2-12.2s-12.2,5.5-12.2,12.2 C41.5,52.2,47,57.8,53.7,57.8z M53.7,41.5c2.2,0,4.1,1.8,4.1,4.1c0,2.2-1.8,4.1-4.1,4.1c-2.2,0-4.1-1.8-4.1-4.1 C49.7,43.4,51.5,41.5,53.7,41.5z M117.3,57.8c6.7,0,12.2-5.5,12.2-12.2c0-6.7-5.5-12.2-12.2-12.2s-12.2,5.5-12.2,12.2 C105.1,52.2,110.5,57.8,117.3,57.8z M117.3,41.5c2.2,0,4.1,1.8,4.1,4.1c0,2.2-1.8,4.1-4.1,4.1c-2.2,0-4.1-1.8-4.1-4.1 C113.2,43.4,115,41.5,117.3,41.5z M80.7,107.9h32.5v29.7H105V116H80.5l5.1,5.1l-5.7,5.8l-15-14.8l15.1-15l5.7,5.8L80.7,107.9z  M41.5,100h8.1v37.7h-8.1v-29.5h-8.1V73.9c0-6.7,5.5-12.2,12.2-12.2h16.3c6.7,0,12.2,5.5,12.2,12.2v4.3h16.1l-5.1-5l5.7-5.8 l15.1,15l-15,14.8l-5.7-5.8l5.1-5H66V73.9c0-2.2-1.8-4.1-4.1-4.1H45.6c-2.2,0-4.1,1.8-4.1,4.1V100z M57.8,116.6l8.1,8v13h-8.1 C57.8,137.6,57.8,116.6,57.8,116.6z M137.6,73.9v34.2h-8.1v29.5h-8.1V99.9h8.1v-26c0-2.2-1.8-4.1-4.1-4.1h-16.3 c-1.1,0-2.2,0.5-2.9,1.2l-5.8-5.7c2.2-2.3,5.3-3.7,8.7-3.7h16.3C132.1,61.7,137.6,67.2,137.6,73.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApoioDecisao);
export default __webpack_public_path__ + "static/media/apoio-decisao.8d882186bb927de748a28144269f8d99.svg";
export { ForwardRef as ReactComponent };